const officerData = [
    {
        section: "Executive Officers",
        members: [
            {
                name: "Alya Mansoor",
                title: "President",
                image: '/Officer_Photos/Alya_Mansoor.png',
                linkedin: 'https://www.linkedin.com/in/alya-mansoor/',
                email: 'dal824459@utdallas.edu',
            },
            {
                name: "Sidrah Rashad",
                title: "Vice President",
                image: '/Officer_Photos/Sidrah_Rashad.jpg',
                linkedin: 'https://www.linkedin.com/in/sidrahrashad/',
                email: 'sxr230168@utdallas.edu',
            },
            {
                name: "Cathryn Saldaña",
                title: "Secretary",
                image: "/Officer_Photos/Cathryn_Saldana.jpg",
                linkedin: 'https://www.linkedin.com/in/cathryn-salda%C3%B1a-b33a6436b/',
                email: 'cis220000@utdallas.edu',
            },
            {
                name: "Toluwalase Adeyemi",
                title: "Treasurer",
                image: '/Officer_Photos/Toluwalase_Adeyemi.jpg',
                linkedin: 'https://www.linkedin.com/in/toluwalase-adeyemi/',
                email: 'txa220038@utdallas.edu',
            },
            {
                name: "Sarah Azeem",
                title: "Treasurer",
                image: '/Officer_Photos/Sarah_Azeem.jpg',
                imageZoom: 1.5,
                linkedin: 'https://www.linkedin.com/in/sarahazeem/',
                email: 'sxa230256@utdallas.edu',
            },
            {
                name: "Waziha Khan",
                title: "Director of Engineering",
                image: '/Officer_Photos/Waziha_Khan.jpg',
                linkedin: 'https://www.linkedin.com/in/-waziha-khan/',
                email: 'Wak240000@utdallas.edu',
            },
            {
                name: "Ugonna Anyalemechi",
                title: "Director of Initiatives",
                image: "/Officer_Photos/Ugonna_Anyalemechi.jpg",
                linkedin: 'https://www.linkedin.com/in/ugonna-anyalemechi/',
                email: 'uaa220000@utdallas.edu',
            },
            {
                name: "Bhavya Kamath",
                title: "Director of Marketing",
                image: "/Officer_Photos/Bhavya_Kamath.jpg",
                linkedin: 'https://www.linkedin.com/in/bhavya-kamath-/',
                email: 'bak230003@utdallas.edu',
            },
            {
                name: "Charlie Wang",
                title: "Director of Outreach",
                image: '/Officer_Photos/Charlie_Wang.jpg',
                linkedin: 'https://www.linkedin.com/in/charlieewangg/',
                email: 'dal282052@utdallas.edu',
            },
            {
                name: "Nana Kakeue",
                title: "Director of Tutoring",
                image: '/Officer_Photos/Nana_Kakeue.jpg',
                imageZoom: 1.2,
                linkedin: 'https://www.linkedin.com/in/nana-kakeue-5ba701334/',
                email: 'nxk230100@utdallas.edu',
            },
            {
                name: "Danish Ejaz",
                title: "Director of Web Development",
                image: "/Officer_Photos/Danish_Ejaz.jpg",
                imagePosition: "50% 0%",
                imageZoom: 1.12,
                linkedin: 'https://www.linkedin.com/in/danishejaz1/',
                email: 'dxe240002@utdallas.edu',
            },
        ]
    },
    {
        section: "Coordinators",
        members: [
            {
                name: "Armaan Srivastava",
                title: "Engineering Coordinator",
                image: "/Officer_Photos/Armaan_Srivastava.jpg",
                imageZoom: 1.5,
                linkedin: 'https://www.linkedin.com/in/srivastava-armaan/',
                email: 'Axs240100@utdallas.edu',
            },
            {
                name: "Gauri Ippalli",
                title: "Engineering Coordinator",
                image: "/Officer_Photos/Gauri_Ippalli.jpg",
                imagePosition: "50% 0%",
                imageZoom: 1.0,
                linkedin: 'https://www.linkedin.com/in/gauri-ippalli-6017902bb/',
                email: 'dal530819@utdallas.edu',
            },
            {
                name: "Varsha Shashishekar",
                title: "Initiatives Coordinator",
                image: "/Officer_Photos/Varsha_Shashishekar.jpg",
                imageZoom: 1.5,
                linkedin: 'https://www.linkedin.com/in/varsha-shashishekar-860b6a263/',
                email: 'dal148885@utdallas.edu',
            },
            {
                name: "Yusra Zainab",
                title: "Marketing Coordinator",
                image: "/Officer_Photos/Yusra_Zainab.jpg",
                imageZoom: 1.5,
                linkedin: 'https://www.linkedin.com/in/yusra-zainab-ce07/',
                email: 'dal641136@utdallas.edu',
            },
            {
                name: "Emilio Aguirre Mijares",
                title: "Outreach Coordinator",
                image: "/Officer_Photos/Emilio_Aguirre_Mijares.jpg",
                linkedin: 'https://www.linkedin.com/in/emilioaguirremijares/',
                email: 'dal336509@utdallas.edu',
            },
            {
                name: "Deston Muo",
                title: "Web Development Coordinator",
                image: '/Officer_Photos/Deston_Muo.jpg',
                imagePosition: "50% 0%",
                imageZoom: 1.3,
                linkedin: 'https://www.linkedin.com/in/deston-muo/',
                email: 'dkm220002@utdallas.edu',
            },
        ]
    },
    {
        section: "Society Directors",
        members: [
            {
                name: "Shradha Gupta",
                title: "CIS Director",
                image: "/Officer_Photos/Shradha_Gupta.jpg",
                linkedin: 'https://www.linkedin.com/in/shradhagupta21/',
                email: 'sxg220208@utdallas.edu',
            },
            {
                name: "Jake Ball",
                title: "PES Director",
                image: "/Officer_Photos/Jake_Ball.jpg",
                linkedin: '',
                email: 'dal760164@utdallas.edu',
                supervisors: [{ name: "Thomas Russo" }, { name: "Johnathan Barrera" }],
            },
            {
                name: "Nevin Sunil",
                title: "RAS Director",
                image: "/Officer_Photos/Nevin_Sunil.jpg",
                linkedin: 'https://www.linkedin.com/in/nevin-sunil/r',
                email: 'njs220004@utdallas.edu',
                supervisors: [
                    { label: "Electrical Lead", name: "Sameer Khan" },
                    { label: "Mechanical Lead", name: "Aarushi Gadkari" },
                ],
            },
            {
                name: "Swaroop Kamble",
                title: "RF Director",
                image: "/Officer_Photos/Swaroop_Kamble.jpg",
                linkedin: 'https://www.linkedin.com/in/swaroop-kamble/',
                email: 'Swaroop.Kamble@utdallas.edu',
                supervisors: [{ name: "Aarush Sarkar" }, { name: "Presley Churchman" }],
            },
            {
                name: "Varun Shiralkar",
                title: "SSCS Director",
                image: "/Officer_Photos/Varun_Shiralkar.jpg",
                linkedin: 'https://www.linkedin.com/in/varun-j-shiralkar/',
                email: 'vjs230002@utdallas.edu',
                supervisors: [{ name: "Anindya Rahman" }],
            },
        ]
    }
];

export default officerData;